import React, { Component } from 'react';
import { Button } from '.';

class ExportExcel extends Component {
  exportExcel() {}

  render() {
    return <Button classes={`clear iconized export ${this.props.classes}`}>{this.props.text || 'Export to excel'}</Button>;
  }
}

export { ExportExcel };
